import { reducer as transactions, namespace as transactionsNamespace } from './transactions';
import { reducer as sessions, namespace as sessionsNamespace } from './sessions';
import * as sessionDetails from './sessionDetails/actions';
import sessionDetailsNamespace from './sessionDetails/namespace';

import * as transaction from './transactionDetails/actions';
import transactionNamespace from './transactionDetails/namespace';

import * as reportTransaction from './reportTransaction/actions';
import reportTransactionNamespace from './reportTransaction/namespace';
import { reducer as virtualTerminal, namespace as virtualTerminalNamespace } from './virtualTerminal';

export interface State {
    [transactionsNamespace]: transactions.State;
    [transactionNamespace]: transaction.State;
    [reportTransactionNamespace]: reportTransaction.State;
    [sessionsNamespace]: sessions.State;
    [sessionDetailsNamespace]: sessionDetails.State;
    [virtualTerminalNamespace]: virtualTerminal.State;
}

export const initialState: State = {
    [transactionsNamespace]: transactions.initialState,
    [transactionNamespace]: transaction.initialState,
    [reportTransactionNamespace]: reportTransaction.initialState,
    [sessionsNamespace]: sessions.initialState,
    [sessionDetailsNamespace]: sessionDetails.initialState,
    [virtualTerminalNamespace]: virtualTerminal.initialState,
};

export const reducers = {
    [transactionsNamespace]: transactions.reducer,
    [transactionNamespace]: transaction.reducer,
    [reportTransactionNamespace]: reportTransaction.reducer,
    [sessionsNamespace]: sessions.reducer,
    [sessionDetailsNamespace]: sessionDetails.reducer,
    [virtualTerminalNamespace]: virtualTerminal.reducer,
};
